import './Footer.css';
import { ArrowRight } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { isBusinessRegistrationBlockedRole } from '../../utils/businessRegistrationAccess';

const Footer = () => {
  const { isAuthenticated, user } = useAuth();
  const canShowBusinessRegistrationLink = !isAuthenticated || !isBusinessRegistrationBlockedRole(user?.role);

  return (
    <footer className="vmc-footer" aria-label="Footer">
      <div className="vmc-footer__main">
        <div className="vmc-footer__grid">
          <section className="vmc-footer__brand" aria-label="Brand">
            <h2 className="vmc-footer__brand-name">VMC Reviews</h2>
            <div className="vmc-footer__rule" />
            <p className="vmc-footer__tagline">
              Trustworthy business reviews connecting consumers and businesses.
            </p>

            <div className="vmc-footer__trust-badge" aria-label="Verified reviews badge">
              <span className="vmc-footer__trust-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 3L14.47 8.02L20 8.82L16 12.72L16.94 18.23L12 15.63L7.06 18.23L8 12.72L4 8.82L9.53 8.02L12 3Z" fill="currentColor" />
                </svg>
              </span>
              <span className="vmc-footer__trust-copy">
                <strong>Verified Reviews</strong>
                <small>Real consumers, real businesses</small>
              </span>
            </div>
          </section>

          <nav className="vmc-footer__nav" aria-label="Explore links">
            <h3 className="vmc-footer__section-label">Explore</h3>
            <a href="/">Home</a>
            <a href="/categories">Categories</a>
            <a href="/businesses">Businesses</a>
            <a href="/businesses?sort=top-rated">Top Rated</a>
          </nav>

          <nav className="vmc-footer__nav" aria-label="Account links">
            <h3 className="vmc-footer__section-label">Account</h3>
            {!isAuthenticated ? (
              <>
                <a href="/login">Login</a>
                <a href="/register">Register</a>
                <a href="/forgot-password">Forgot Password</a>
              </>
            ) : (
              <>
                {user?.role === 'consumer' && (
                  <>
                    <a href="/consumer/reviews">My Reviews</a>
                    <a href="/consumer/profile">My Profile</a>
                    <a href="/consumer/dashboard">Dashboard</a>
                  </>
                )}
                {user?.role === 'business_owner' && (
                  <>
                    <a href="/business/dashboard">Dashboard</a>
                    <a href="/business/reviews">Reviews</a>
                    <a href="/business/profile">Profile</a>
                  </>
                )}
                {user?.role === 'admin' && (
                  <>
                    <a href="/admin/dashboard">Admin Dashboard</a>
                  </>
                )}
              </>
            )}
          </nav>

          <section className="vmc-footer__cta-col" aria-label="Business call to action">
            <h3 className="vmc-footer__section-label">For Businesses</h3>
            <div className="vmc-footer__cta-card">
              <p className="vmc-footer__cta-eyebrow">Get listed</p>
              <h4 className="vmc-footer__cta-title">Grow with VMC</h4>
              <p className="vmc-footer__cta-description">
              </p>
              {canShowBusinessRegistrationLink && (
                <a href="/register-business" className="vmc-footer__cta-button">
                  <ArrowRight size={16} className="mr-2" style={{display: 'inline'}} />
                  Register Business
                </a>
              )}
            </div>
          </section>
        </div>
      </div>

      <div className="vmc-footer__bottom-wrap">
        <div className="vmc-footer__bottom">
          <p>&copy; 2026 VMC Reviews. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
